export enum CampanhaStatus {
  Rascunho = 'R',
  Agendada = 'AG',
  AtivoPortal = 'AP',
  Encerrada = 'EN',
  Cancelada = 'C',
  Pausada = 'P',
}
